var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"snackbar",class:_vm.snack.Active ? `active ${_vm.snack.ClassName}` : `${_vm.snack.ClassName}`},[_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.snack.Title)))]),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.snack.Msg)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }